'use strict';

const jQuery = require('jquery');
const mediator = require('./../core/mediator');

module.exports.init = function() {
    jQuery(window).on('resize', function(e) {
        mediator.publish('window:resize', {'event': e});
    });
};
